const FileValidationEnum = require('../enums/FileValidityEnums');
const { FILE_SIZE_LIMIT, MAX_FILES_LIMIT, ALLOWED_FILE_TYPES, MAX_FILENAME_LENGTH } = FileValidationEnum;

export const validateFiles = (files) => {
  const validFiles = [];
  let invalidTypeCount = 0;
  let invalidSizeCount = 0;
  let invalidNameCount = 0;
  const FILE_SIZE_LIMIT_MB = FILE_SIZE_LIMIT / (1024 * 1024);
  
  // Check if total files exceed limit
  if (files.length > MAX_FILES_LIMIT) {
    return {
      validFiles: [],
      errorMessage: `Cannot upload more than ${MAX_FILES_LIMIT} files at once!`,
      hasErrors: true
    };
  }

  Array.from(files).forEach(file => {
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      invalidTypeCount++;
      return;
    }

    if (file.size > FILE_SIZE_LIMIT) {
      invalidSizeCount++;
      return;
    }

    if (file.name.length > MAX_FILENAME_LENGTH) {
      invalidNameCount++;
      return;
    }

    validFiles.push(file);
  });

  // Generate appropriate error message
  let errorMessage = '';
  const errorParts = [];
  
  if (invalidTypeCount > 0) {
    errorParts.push(invalidTypeCount === 1 
      ? 'File type is not supported' 
      : `${invalidTypeCount} files are of unsupported file type`);
  }

  if (invalidSizeCount > 0) {
    errorParts.push(invalidSizeCount === 1 
      ? `File size exceeds ${FILE_SIZE_LIMIT_MB}MB limit` 
      : `${invalidSizeCount} files exceed the ${FILE_SIZE_LIMIT_MB}MB size limit`);
  }

  if (invalidNameCount > 0) {
    errorParts.push(invalidNameCount === 1 
      ? `Filename exceeds ${MAX_FILENAME_LENGTH} character limit` 
      : `${invalidNameCount} filenames exceed the ${MAX_FILENAME_LENGTH} character limit`);
  }

  // Join error parts with proper grammar
  if (errorParts.length > 1) {
    errorMessage = errorParts.slice(0, -1).join(', ') + ' and ' + errorParts[errorParts.length - 1];
  } else if (errorParts.length === 1) {
    errorMessage = errorParts[0];
  }

  return { 
    validFiles, 
    errorMessage,
    hasErrors: invalidTypeCount > 0 || invalidSizeCount > 0 || invalidNameCount > 0
  };
};